import CardsWrapper from '../../cardsWrapper';
import RealEstateCardView from '../realEstateCardView/realEstateCard.view';
import { FC } from 'react';
import { useRoomNavigation } from '../../hooks/useRoomNavigation';
import { RealEstateCardProps } from '../realEstateCard.types';
// import { ReactComponent as OrtakSvg } from '../../../../assets/icons/Ortak.svg';
// import { ReactComponent as YoEstateIcon } from '../../../../assets/icons/yoEstate.svg';
// import styles from './styles.module.scss';

export const RealEstateCardController: FC<RealEstateCardProps> = ({
  room,
  index,
  className,
}) => {
  const { openCopiaHandler } = useRoomNavigation(room, () => {});

  // const ortakIcon = useMemo(() => {
  //   return isOrtak ? (
  //     <div className={cn(styles.ortakIcon, styles.badge)}>
  //       <OrtakSvg
  //         onClick={(e) => {
  //           e.stopPropagation();
  //           window.open(room.websiteLink, '_blank');
  //         }}
  //       />
  //     </div>
  //   ) : (
  //     <></>
  //   );
  // }, [isOrtak, room.websiteLink]);

  // const yoEstateIcon = useMemo(() => {
  //   return (
  //     room?.yoEstateUrl && (
  //       <div
  //         className={cn(styles.yoEstateBadge, styles.badge)}
  //         onClick={(e) => {
  //           e.stopPropagation();
  //           window.open(room?.yoEstateUrl, '_blank');
  //         }}
  //       >
  //         <span className={styles.badgeIcon}>
  //           <YoEstateIcon width={21} height="auto" />
  //         </span>
  //         <span className={styles.badgeText}>YoEstate</span>
  //       </div>
  //     )
  //   );
  // }, [room.yoEstateUrl]);

  return (
    <>
      <CardsWrapper
        image={room.logo}
        action={openCopiaHandler}
        room={room}
        // marker={room.yoEstateUrl ? yoEstateIcon : ortakIcon}
        className={className}
      >
        <RealEstateCardView room={room} index={index} />
      </CardsWrapper>
    </>
  );
};
